import { Card, CardContent } from '@shared/shared-shadcn-ui';
import { cn } from '@shared/shared-utils';
import ExportedImage from 'next-image-export-optimizer';
import { FC } from 'react';

type Properties = {
  caption: string;
  preview?: string;
  isActive?: boolean;
  onClick?: () => void;
  className?: string;
};

const VideoThoughtsCarouselCard: FC<Properties> = ({
  caption,
  preview,
  isActive = false,
  onClick,
  className,
}: Properties) => {
  return (
    <Card
      onClick={onClick}
      className={cn(
        'p-6 cursor-pointer transition-all duration-300 ease-in-out border-0 margin-0 h-full flex flex-col w-full max-w-full min-w-0 overflow-hidden',
        !isActive ? 'bg-ogn-blue hover:bg-ogn-blue/90' : 'bg-ogn-white',
        className,
      )}
    >
      <CardContent className="flex flex-col gap-y-4 p-0 flex-1 min-w-0 overflow-hidden">
        <div className="bg-gray-400 w-full h-auto aspect-[2/1] transition-transform duration-300 hover:scale-105 overflow-hidden max-w-full relative">
          {preview ? (
            <ExportedImage
              src={preview}
              alt={caption}
              fill
              className="object-cover"
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            />
          ) : (
            <div className="w-full h-full bg-gray-400" />
          )}
        </div>
        <p
          className={cn(
            'text-[18px] font-bold transition-colors duration-300',
            !isActive ? 'text-ogn-white' : 'text-ogn-blue',
          )}
        >
          {caption}
        </p>
      </CardContent>
    </Card>
  );
};

export { VideoThoughtsCarouselCard };
